import React, { useRef, useEffect } from "react";

const CameraModal = ({ onClose, onCapture }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);

    useEffect(() => {
        startCamera();
        return stopCamera;
    }, []);

    // Start Camera
    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            videoRef.current.srcObject = stream;
            videoRef.current.play();
        } catch (err) {
            alert("Camera not available");
            onClose();
        }
    };

    // Stop Camera
    const stopCamera = () => {
        const stream = videoRef.current?.srcObject;
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
    };

    // Capture the Photo
    const capturePhoto = () => {
        const canvas = canvasRef.current;
        const video = videoRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0);

        canvas.toBlob((blob) => {
            const file = new File([blob], "captured.jpg", { type: "image/jpeg" });
            onCapture(file);
            onClose();
        }, "image/jpeg");
    };

    return (
        <div
            className="modal-overlay position-fixed top-0 start-0 w-100 h-100 bg-dark d-flex justify-content-center align-items-center"
            style={{ zIndex: 99999 }}
        >
            <div className="camera-container position-relative w-100 h-100">

                {/* CAMERA VIDEO */}
                <video ref={videoRef} className="w-100 h-100 object-fit-cover" />

                <canvas ref={canvasRef} className="d-none" />

                {/* BOTTOM BUTTONS */}
                <div className="position-absolute bottom-0 w-100 d-flex justify-content-between p-4">

                    {/* ❌ Cancel */}
                    <button
                        className="btn btn-danger px-4 py-2"
                        onClick={onClose}
                    >
                        Cancel
                    </button>

                    {/* 📸 Capture */}
                    <button
                        className="btn btn-success px-4 py-2"
                        onClick={capturePhoto}
                    >
                        Capture
                    </button>

                </div>
            </div>
        </div>

    );
};

export default CameraModal;
